import { render, staticRenderFns } from "./OfertaCarrinhoGrades.vue?vue&type=template&id=56597a0a"
import script from "./OfertaCarrinhoGrades.vue?vue&type=script&lang=js"
export * from "./OfertaCarrinhoGrades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports